import i18next from 'i18next'
import { z } from 'zod'

import { emptySelectOptionZod, SelectOptionZod, selectOptionZod } from 'components/Select'
import { userWorkspaceRoles } from 'features/user/types/userWorkspaceRole'
import { WorkspaceSlice } from '../hooks/useGetWorkspaceOptions'

const userWorkspaceAttribute = z.object({
  role: z.enum(userWorkspaceRoles),
  workspaceId: selectOptionZod<WorkspaceSlice>().refine(
    (value: SelectOptionZod<WorkspaceSlice>): boolean => value.value !== '',
    i18next.t('common:form.error.nonEmpty'),
  ),
})

export type UserWorkspaceAttribute = z.infer<typeof userWorkspaceAttribute>

export const schema = z.object({
  email: z.email(),
  userWorkspaceAttributes: z.array(userWorkspaceAttribute),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault: Schema = {
  email: '',
  userWorkspaceAttributes: [
    {
      role: 'viewer',
      workspaceId: emptySelectOptionZod<WorkspaceSlice>(),
    },
  ],
}
